// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PostImageGridItem_overlay__mD0ue"};